/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  ApproveMonthlyCoveragePlan,
  CancelMonthlyCoveragePlan,
  CreateMonthlyCoveragePlan,
  MonthlyCoveragePlanDto,
  PagedResultOfMonthlyCoveragePlanSummaryDto,
  ReviseMonthlyCoveragePlan,
  SaveMonthlyCoveragePlan,
  SearchMonthlyCoveragePlansParams,
  SubmitMonthlyCoveragePlan,
  UpdateMonthlyCoveragePlan
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns a paged list of monthlycoverageplans matching the supplied filter and sort criteria.
 */
export const searchMonthlyCoveragePlans = (
    params?: SearchMonthlyCoveragePlansParams,
 options?: SecondParameter<typeof customInstance<PagedResultOfMonthlyCoveragePlanSummaryDto>>,) => {
      return customInstance<PagedResultOfMonthlyCoveragePlanSummaryDto>(
      {url: `/deployment/monthly-coverage-plans`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Creates a new MonthlyCoveragePlan from the supplied command.
 */
export const createMonthlyCoveragePlan = (
    createMonthlyCoveragePlan: CreateMonthlyCoveragePlan,
 options?: SecondParameter<typeof customInstance<MonthlyCoveragePlanDto>>,) => {
      return customInstance<MonthlyCoveragePlanDto>(
      {url: `/deployment/monthly-coverage-plans`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMonthlyCoveragePlan
    },
      options);
    }
  /**
 * @summary Returns the MonthlyCoveragePlan identified by the route id.
 */
export const getMonthlyCoveragePlanById = (
    id: string,
 options?: SecondParameter<typeof customInstance<MonthlyCoveragePlanDto>>,) => {
      return customInstance<MonthlyCoveragePlanDto>(
      {url: `/deployment/monthly-coverage-plans/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Removes the MonthlyCoveragePlan identified by the route id.
 */
export const deleteMonthlyCoveragePlan = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/deployment/monthly-coverage-plans/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Change requestid.
 */
export const updateMonthlyCoveragePlan = (
    id: string,
    updateMonthlyCoveragePlan: UpdateMonthlyCoveragePlan,
 options?: SecondParameter<typeof customInstance<MonthlyCoveragePlanDto>>,) => {
      return customInstance<MonthlyCoveragePlanDto>(
      {url: `/deployment/monthly-coverage-plans/${id}/change-requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateMonthlyCoveragePlan
    },
      options);
    }
  /**
 * @summary SaveMonthlyCoveragePlan
 */
export const saveMonthlyCoveragePlan = (
    id: string,
    saveMonthlyCoveragePlan: SaveMonthlyCoveragePlan,
 options?: SecondParameter<typeof customInstance<MonthlyCoveragePlanDto>>,) => {
      return customInstance<MonthlyCoveragePlanDto>(
      {url: `/deployment/monthly-coverage-plans/${id}/save`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveMonthlyCoveragePlan
    },
      options);
    }
  export const validateByIdMonthlyCoveragePlans = (
    coordinatorId: string,
    year: number,
    monthId: number,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/deployment/monthly-coverage-plans/${coordinatorId}/${year}/${monthId}/validate`, method: 'GET'
    },
      options);
    }
  /**
 * @summary SubmitMonthlyCoveragePlan
 */
export const submitMonthlyCoveragePlan = (
    id: string,
    submitMonthlyCoveragePlan: SubmitMonthlyCoveragePlan,
 options?: SecondParameter<typeof customInstance<MonthlyCoveragePlanDto>>,) => {
      return customInstance<MonthlyCoveragePlanDto>(
      {url: `/deployment/monthly-coverage-plans/${id}/submit`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: submitMonthlyCoveragePlan
    },
      options);
    }
  /**
 * @summary ApproveMonthlyCoveragePlan
 */
export const approveMonthlyCoveragePlan = (
    id: string,
    approveMonthlyCoveragePlan: ApproveMonthlyCoveragePlan,
 options?: SecondParameter<typeof customInstance<MonthlyCoveragePlanDto>>,) => {
      return customInstance<MonthlyCoveragePlanDto>(
      {url: `/deployment/monthly-coverage-plans/${id}/approve`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: approveMonthlyCoveragePlan
    },
      options);
    }
  /**
 * @summary ReviseMonthlyCoveragePlan
 */
export const reviseMonthlyCoveragePlan = (
    id: string,
    reviseMonthlyCoveragePlan: ReviseMonthlyCoveragePlan,
 options?: SecondParameter<typeof customInstance<MonthlyCoveragePlanDto>>,) => {
      return customInstance<MonthlyCoveragePlanDto>(
      {url: `/deployment/monthly-coverage-plans/${id}/revise`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: reviseMonthlyCoveragePlan
    },
      options);
    }
  /**
 * @summary CancelMonthlyCoveragePlan
 */
export const cancelMonthlyCoveragePlan = (
    id: string,
    cancelMonthlyCoveragePlan: CancelMonthlyCoveragePlan,
 options?: SecondParameter<typeof customInstance<MonthlyCoveragePlanDto>>,) => {
      return customInstance<MonthlyCoveragePlanDto>(
      {url: `/deployment/monthly-coverage-plans/${id}/cancel`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: cancelMonthlyCoveragePlan
    },
      options);
    }
  export type SearchMonthlyCoveragePlansResult = NonNullable<Awaited<ReturnType<typeof searchMonthlyCoveragePlans>>>
export type CreateMonthlyCoveragePlanResult = NonNullable<Awaited<ReturnType<typeof createMonthlyCoveragePlan>>>
export type GetMonthlyCoveragePlanByIdResult = NonNullable<Awaited<ReturnType<typeof getMonthlyCoveragePlanById>>>
export type DeleteMonthlyCoveragePlanResult = NonNullable<Awaited<ReturnType<typeof deleteMonthlyCoveragePlan>>>
export type UpdateMonthlyCoveragePlanResult = NonNullable<Awaited<ReturnType<typeof updateMonthlyCoveragePlan>>>
export type SaveMonthlyCoveragePlanResult = NonNullable<Awaited<ReturnType<typeof saveMonthlyCoveragePlan>>>
export type ValidateByIdMonthlyCoveragePlansResult = NonNullable<Awaited<ReturnType<typeof validateByIdMonthlyCoveragePlans>>>
export type SubmitMonthlyCoveragePlanResult = NonNullable<Awaited<ReturnType<typeof submitMonthlyCoveragePlan>>>
export type ApproveMonthlyCoveragePlanResult = NonNullable<Awaited<ReturnType<typeof approveMonthlyCoveragePlan>>>
export type ReviseMonthlyCoveragePlanResult = NonNullable<Awaited<ReturnType<typeof reviseMonthlyCoveragePlan>>>
export type CancelMonthlyCoveragePlanResult = NonNullable<Awaited<ReturnType<typeof cancelMonthlyCoveragePlan>>>
